import React from "react";
import VPTopDtcComplaints from "../../Diagonstic/Top10DtcComplaints/Top10DtcComplaints"

const VPTopDtcComplaintsPrognostic = () => {
  return <VPTopDtcComplaints route="prognostics" />;
};

export default VPTopDtcComplaintsPrognostic;
